import { useEffect, useState } from "react";
import dayjs from "dayjs";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {
  InputLabel,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Button,
  Grid,
} from "@mui/material";
import { useSelector } from "react-redux";

const emptyTaskData = {
  task_name: "",
  start_date: "",
  end_date: "",
  budget: 0,
  task_type: "FIXED",
  task_description: "",
  status: "WIP",
  parent_task_id: null,
  task_code: "",
};
export default function UpdateTaskDialog({
  open,
  setOpen,
  onUpdate,
  selectedTaskId,
  allTasks,
  lowestTasks,
  projectData,
}) {
  const [data, setData] = useState(emptyTaskData);
  const user = useSelector((state) => state.user);

  const userIsNotAdminNorPM =
    projectData.pm_id !== user.roleId && user.role !== "Admin";

  useEffect(() => {
    if (!open) return;
    setData(allTasks.find((t) => t.id === selectedTaskId));
  }, [selectedTaskId]);

  const [dateBoundry, setDateBoundry] = useState({
    start_date: "",
    end_date: "",
  });

  const handleDataChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onTaskIdChange = (e) => {
    const { name, value } = e.target;
    if (!value) {
      setData((prev) => ({ ...prev, [name]: "" }));
    } else {
      let chosenParentTask = allTasks.find((t) => t.id === value);
      setDateBoundry({
        start_date: chosenParentTask.start_date,
        end_date: chosenParentTask.end_date,
      });
      setData((prev) => ({
        ...prev,
        task_code: chosenParentTask.task_code + ".",
        start_date: chosenParentTask.start_date,
        end_date: chosenParentTask.end_date,
        [name]: value,
      }));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen("UPDATE_TASK");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // const errors = validate(data);
          // if (Object.keys(errors).length === 0) {
          let d = getUpdatableTaskData(data);
          onUpdate(d);

          // }
        }}
      >
        <DialogTitle id="alert-dialog-title">Update Task</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ pt: 2 }}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                fullWidth
                label="Name"
                className="name-textfeild"
                name="task_name"
                value={data.task_name}
                onChange={handleDataChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Parent Task
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={data.parent_task_id || ""}
                  label="Parent Task Code"
                  name="parent_task_id"
                  disabled={userIsNotAdminNorPM}
                  onChange={onTaskIdChange}
                >
                  <MenuItem value="0">Choose</MenuItem>
                  {allTasks
                    .filter((t) => t.id !== selectedTaskId)
                    .map((t, i) => (
                      <MenuItem key={i} value={t.id}>
                        {t.task_code} - {t.task_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                required
                label="Task Code"
                fullWidth
                name="task_code"
                disabled={userIsNotAdminNorPM}
                value={data.task_code}
                onChange={handleDataChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label-ts">Status</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-label-ts"
                  id="demo-simple-select-ts"
                  value={data.status || ""}
                  label="Status"
                  name="status"
                  onChange={handleDataChange}
                >
                  <MenuItem value="COMPLETED">Completed</MenuItem>
                  <MenuItem value="WIP">In Progress</MenuItem>
                  <MenuItem value="PENDING">Pending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  required
                  inputFormat="MM/dd/yyyy"
                  label="Start Date"
                  disabled={userIsNotAdminNorPM}
                  value={new Date(data.start_date)}
                  minDate={getMinPossibleTaskStartDate(
                    dateBoundry.start_date,
                    projectData.start_date
                  )}
                  maxDate={
                    new Date(
                      dateBoundry.end_date || new Date(projectData.end_date)
                    )
                  }
                  // value={new Date(data.start_date)}
                  // minDate={getMinPossibleTaskStartDate(
                  //   dateBoundry.start_date,
                  //   projectData.start_date
                  // )}
                  // maxDate={new Date(dateBoundry.end_date)}
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "start_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  required
                  inputFormat="MM/dd/yyyy"
                  label="End Date"
                  value={new Date(data.end_date)}
                  minDate={new Date(data.start_date)}
                  maxDate={getMaxPossibleTaskEndDate(
                    dateBoundry.end_date,
                    projectData.end_date
                  )}
                  // value={new Date(data.end_date)}
                  // minDate={new Date(data.start_date)}
                  disabled={userIsNotAdminNorPM}
                  // maxDate={getMaxPossibleTaskEndDate(
                  //   dateBoundry.end_date,
                  //   projectData.end_date
                  // )}
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "end_date", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            {lowestTasks.map((l) => l.id).includes(selectedTaskId) ? (
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  required
                  label="% Complete"
                  fullWidth
                  name="percent_complete"
                  type="number"
                  value={data.percent_complete}
                  onChange={handleDataChange}
                />
              </Grid>
            ) : (
              <></>
            )}

            <Grid item xs={12} md={12}>
              <TextField
                required
                label="Description"
                fullWidth
                disabled={userIsNotAdminNorPM}
                name="task_description"
                value={data.task_description}
                onChange={handleDataChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen("UPDATE_TASK");
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            // onClick={() => {
            //   let d = getUpdatableTaskData(data);
            //   onUpdate(d);
            // }}
            className="blue-button"
          >
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

function getMinPossibleTaskStartDate(d1, d2) {
  return dayjs(d1).isAfter(dayjs(d2)) ? new Date(d1) : new Date(d2);
}

function getMaxPossibleTaskEndDate(d1, d2) {
  return dayjs(d1).isBefore(dayjs(d2)) ? new Date(d1) : new Date(d2);
}

function getUpdatableTaskData(data) {
  return {
    parent_task_id: data.parent_task_id,
    percent_complete: data.percent_complete,
    task_name: data.task_name,
    start_date: data.start_date,
    end_date: data.end_date,
    budget: data.budget,
    task_description: data.task_description,
    status: data.status,
    task_code: data.task_code,
    task_type: data.task_type,
  };
}
